import {POST} from "@/services/gateway";

const listItems = ({pagination, userIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('exchange/todo/search', {pagination, userIds, snapshotDateTime, folderId, searchTerm});
}

const listTaskBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('exchange/todo/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('exchange/todo/export', {snapshotDateTime, sourceIds, searchTerm, selectedIds}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, code}) => {
  return POST('exchange/todo/restore', {snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds}, {code: code ? code : null})
}

export {
  listItems,
  listTaskBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
